import React, { useState } from "react";
import fetchData from "../services/requester";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import Config from "../config.json";

const ResultFiltersDestination = (props) => {
  const { liveMode } = Config;
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const handleSearch = (query) => {
    let req = "quickItinerary/searchDestinations/" + query + "/dummy";
    let obj = "";
    fetchData(
      req,
      obj,
      (data) => {
        let items = [];
        data.map((x) => x.data.map((y) => items.push({ ...y })));
        setOptions(items);
        setIsLoading(false);
      },
      "GET"
    );
  };

  const handleSearchOffline = (query) => {
    const req = "destinations.json";
    const obj = "";

    setIsLoading(true);
    fetchData(
      req,
      obj,
      (data) => {
        let items = [];
        const lowerQuery = query.toLowerCase();
        data.forEach((entry) => {
          if (entry.toLowerCase().includes(lowerQuery)) {
            items.push({ name: entry.trim() });
          }
        });
        setOptions(items);
        setIsLoading(false);
      },
      "GET"
    );
  };

  const onChange = (item) => {
    props.handleFilters("destinations", item);
  };

  const filterBy = () => true;

  return (
    <div className="filters-destination">
      <h4>Destination</h4>

      <div className="custom-autocomplate">
        <AsyncTypeahead
          filterBy={filterBy}
          id="async-example"
          isLoading={isLoading}
          labelKey="name"
          minLength={3}
          onSearch={liveMode ? handleSearch : handleSearchOffline}
          options={options}
          placeholder="City, Country, Continent"
          renderMenuItemChildren={(option) => (
            <div>
              <h5>
                {option?.name}
                <span>{option?.type}</span>
              </h5>
            </div>
          )}
          onChange={onChange}
          multiple
        />
      </div>
    </div>
  );
};

export default ResultFiltersDestination;
